// extracted by mini-css-extract-plugin
export default {"icon":"z12s8uSUTUeHLVzo3BgK","container":"HNf1l_N7kAPqZAhRpkth"};